import { __decorate } from "tslib";
import { Component, Vue, Ref, Watch } from 'vue-property-decorator';
import { AppModule } from '@blade/common/store/app';
import { getDevicegroupsTree, creatTreeGroup, updateTreeGroup } from '@blade-sxp/pass/api/access-management/device-management';
let default_1 = class default_1 extends Vue {
    tree;
    form = { groupName: '' };
    title = '';
    groupName = '';
    dialogVisible = false;
    value = '';
    selectOpts = [];
    outerPage = 1;
    outerPageSize = 10;
    outerOpen = false;
    icon = false;
    mode = 'ORGAEDIT';
    currIndex = 0;
    parentId = 0;
    treeData = [];
    command = 0;
    mounted() {
        this.getData();
    }
    get language() {
        return AppModule.language;
    }
    getData() {
        let data = {
            keyword: this.value,
        };
        getDevicegroupsTree(data)
            .then((resp) => {
            if (resp.data.data) {
                this.treeData = resp.data.data.tree;
            }
            else {
                this.treeData = [];
            }
        })
            .catch((err) => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    handleNodeClick(node) {
        console.log(node);
        this.currIndex = node.id;
        this.parentId = node.parentId;
        this.$emit('getroupId', node.id);
    }
    handleRenderContent(h, { node, data, store }) {
        if (data.level !== 0) {
            return (<div class="content-left-item">
          {data.parentId !== 0 && <i class="el-icon-share" style="color:#ddd"></i>}
          <div class={{ 'item-active': data.id === this.currIndex }} id="textWraper">
            {data.name}
          </div>
        </div>);
        }
    }
    /**
     *@Description: 创建/修改 设备组
     *@Date: 2020-09-08 16:44:09
     */
    handleSubmit() {
        console.log(this.command);
        if (this.command === 1 || this.command === 2) {
            let data = { name: this.groupName, parentId: 0 };
            if (this.command === 1) {
                // 创建同级
                data.parentId = this.parentId;
            }
            else if (this.command === 2) {
                // 创建下一级
                data.parentId = this.currIndex;
                // console.log(data.parentId);
            }
            creatTreeGroup(data)
                .then((resp) => {
                this.getData();
                this.dialogVisible = false;
                this.$message({
                    message: resp.data.message,
                    type: 'success',
                });
            })
                .catch((err) => {
                this.$message({
                    message: err,
                    type: 'error',
                });
            });
        }
        else if (this.command === 3) {
            // 重命名
            updateTreeGroup(this.currIndex, { name: this.groupName, groupId: this.currIndex })
                .then((resp) => {
                this.getData();
                this.dialogVisible = false;
                this.$message({
                    message: resp.data.message,
                    type: 'success',
                });
            })
                .catch((err) => {
                this.$message({
                    message: err,
                    type: 'error',
                });
            });
        }
    }
    creatFirst() {
        this.title = `${this.$t('device.createdAtTheSameLevel')}`;
        this.command = 1;
        this.parentId = 0;
        this.dialogVisible = true;
    }
    handleDragStart(node, $event) {
        this.$refs.tree.setCurrentKey(node.data.id);
        $event.dataTransfer.setData('drag', JSON.stringify(node.data));
    }
    handleDrag(node) {
        if (node.childNodes.length === 0) {
            return true;
        }
        return false;
    }
    handleSearch() {
        this.getData();
    }
    filterNode(value, data, node) {
        console.log(value, data, node, 9999);
        return this.filterNodeAndParent(value, data, node);
    }
    // 递归检测父元素或自己是否符合条件
    filterNodeAndParent(value, data, node) {
        if (node.level === 1) {
            return node.data.label.indexOf(value) !== -1;
        }
        else if (data.level !== 1) {
            // 判断自己是否符合条件
            if (node.data.label.indexOf(value) !== -1) {
                return true;
            }
            else {
                // 否则查找父级
                return this.filterNodeAndParent(value, node.data, node.parent);
            }
        }
    }
    watchValue(newVal, oldVal) {
        if (newVal == '') {
            this.getData();
        }
    }
    watchLan(newVal) {
        if (newVal === 'en-us') {
            this.icon = true;
        }
        else {
            this.icon = false;
        }
    }
    handleClear() {
        this.value = '';
    }
};
__decorate([
    Ref()
], default_1.prototype, "tree", void 0);
__decorate([
    Watch('value')
], default_1.prototype, "watchValue", null);
__decorate([
    Watch('language', { deep: true, immediate: true })
], default_1.prototype, "watchLan", null);
default_1 = __decorate([
    Component({
        name: 'ControlLeft',
        i18n: {
            messages: {
                'en-us': {
                    toAdd: 'No Record, click to add',
                },
                zh: {
                    toAdd: '暂无数据点击添加',
                },
            },
        },
    })
], default_1);
export default default_1;
